import { Component, OnInit, ViewChild, HostListener } from '@angular/core';
import {
  AbstractControl,
  FormBuilder,
  FormControl,
  NgModel,
  Validators,
} from '@angular/forms';
import { ThemePalette } from '@angular/material/core';
import moment from 'moment';
import {
  Observable,
  filter,
  map,
  tap,
  observable,
  finalize,
  catchError,
  throwError,
  of,
} from 'rxjs';

import { APIBlockedAttentionSchedules } from 'src/services/api-services/api-blocked-attention-schedule';
import { APIcityService } from 'src/services/api-services/api-city-service';
import { APICustomScheduleService } from 'src/services/api-services/api-custom-schedule-service';
import { APICustomerBasicDataService } from 'src/services/api-services/api-customer-basic-data-service';
import { APIDealerBlockedServices } from 'src/services/api-services/api-dealer-blocked-services';
import { ServiceAdvisorBlockedSchedule } from 'src/services/api-services/api-interfaces/api-interface-advisor-blocked-schedule';
import { ServiceAdvisorShedule } from 'src/services/api-services/api-interfaces/api-interface-service-advisor-schedule';
import { Representative } from 'src/services/api-services/api-interfaces/api-representative.interface';
import { CustomerBasicData } from 'src/services/api-services/api-interfaces/customerBasicData.interface';
import { typeOfService } from 'src/services/api-services/api-interfaces/typeOfService.interface';
import { unavaibleAdvisorHours } from 'src/services/api-services/api-interfaces/unavaibleAdvisorHours.interface';
import { VehicleData } from 'src/services/api-services/api-interfaces/vehicleData.interface';
import { APIRepresentativeService } from 'src/services/api-services/api-representative-service';
import { APISchedulerService } from 'src/services/api-services/api-scheduler-service';
import { APIService } from 'src/services/api-services/api-service';
import { APIServiceAdvisorSchedule } from 'src/services/api-services/api-service-advisor-schedule';
import { APIAttentionSchedule } from 'src/services/api-services/api-service-attention-schedule';
import { APIServiceAdvisorService } from 'src/services/api-services/api-serviceadvisor-service';
import { APIWorkshopService } from 'src/services/api-services/api-workshop.service';
import { VehicleDataService } from 'src/services/api-services/vehicleData-service';
import { HelperService } from 'src/services/helperService';
import { APIServiceAdvisorBlockedSchedule } from 'src/services/api-services/api-advisor-blocked-schedule-service';
import { APIDocumentTypeService } from 'src/services/api-services/api-document-type.service';
import { TranslateService } from '@ngx-translate/core';
import { ActivatedRoute, Router } from '@angular/router';
import { RespDeptMakes } from 'src/services/incadea/incadea-interfaces/responses/ResponseDeptMakes.interface';
import { ResponseServices } from 'src/services/incadea/incadea-interfaces/responses/ResponseServices.interface';
import { GetDepartmentsService } from '../../../../services/incadea/incadea-services/getDepartments.service';
import { GetMakesService } from '../../../../services/incadea/incadea-services/getMakes.service';
import { GetServicesService } from 'src/services/incadea/incadea-services/getServices.service';
import { GetResourcesService } from 'src/services/incadea/incadea-services/getResources.service';
import { ResponseResources } from 'src/services/incadea/incadea-interfaces/responses/ResponseResources.interface';
import { GetTimeSlotsService } from 'src/services/incadea/incadea-services/getTimeSlots.service';
import { ResponseTimeSlots } from 'src/services/incadea/incadea-interfaces/responses/ResponseTimeSlots.interface';
import DocumentType from 'src/services/api-services/api-interfaces/documentType.interface';
import { GetAppointmentCreate } from 'src/services/incadea/incadea-services/getAppointmentCreate.service';
import { AppointmentCreate } from 'src/services/incadea/incadea-interfaces/requests/RequestAppointmentCreate.interface';
import { IncadeaBookingService } from 'src/services/api-services/IncadeaBooking.service';
import { ABappointment } from 'src/services/api-services/api-interfaces/IBAppointment.interface';
import { ResponseAppointment } from 'src/services/incadea/incadea-interfaces/responses/ResponseAppointment.interface';
import {
  IBAppointmentGET,
  IncadeaAppointment,
} from 'src/services/api-services/api-interfaces/IBAppointmentGET.interface';
import { APITermsAndPolitics } from 'src/services/api-services/api-terms-and-politics.service';
import { termsAndConditions } from 'src/services/api-services/api-interfaces/api-interface-terms-conditions';
import { MatTooltip as MatTooltip } from '@angular/material/tooltip';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';

export interface Task {
  name: string;
  completed: boolean;
  color: ThemePalette;
  subtasks?: Task[];
}
declare const grecaptcha: any;
const noSpecialCharsValidator = (
  control: AbstractControl
): { [key: string]: any } | null => {
  const noSpecialChars = /^[^*+=,\/#!$%\^\*;:{}\[\]~()<>\?|]+$/;
  const forbidden = !noSpecialChars.test(control.value);
  return forbidden ? { noSpecialChars: { value: control.value } } : null;
};
const emailValidator = (
  control: AbstractControl
): { [key: string]: any } | null => {
  const emailPattern = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/;
  const forbidden = !emailPattern.test(control.value);
  return forbidden ? { invalidEmail: { value: control.value } } : null;
};
@Component({
    selector: 'app-i-create-appointment',
    templateUrl: './i-create-appointment.component.html',
    styleUrls: ['./i-create-appointment.component.sass'],
    standalone: false
})
export class ICreateAppointmentComponent implements OnInit {
  [x: string]: any;
  typesOfDocumentRepresentative: string[] = [
    'CC',
    'CE',
    'NIP',
    'NIT',
    'TI',
    'PAP',
  ];
  relationsRepresentativeVC: string[] = [
    'Antiguo dueño',
    'Copropiertario',
    'Conductor',
    'Persona de Contacto',
    'Otro',
  ];
  relationsVC: string[] = [
    'Dueño',
    'Antiguo dueño',
    'Copropiertario',
    'Conductor',
    'Persona de Contacto',
    'Otro',
  ];
  typeOfServices: string[] = [];
  mileages: string[] = [];

  // -----data to remove on the future to remove hardcoded values ---------

  public recievedScheduledData: IncadeaAppointment = history.state
    .schedule as IncadeaAppointment;
  public recievedBrand: any = history.state.brand as {};
  public recievedCountryData: any = history.state.country as {};
  public recievedCityData: any = history.state.cityId as {};
  public recievedLanguageForCountry: any = history.state
    .LanguageForCountry as {};
  public receivedTokenIncadea: any = history.state.tokenIncadea as {};
  public receivedlocationSelect: any = history.state.locationSelect as {};
  public receivedcompaniesSelect: any = history.state.companiesSelect as {};
  public receivedNameCountry: any = history.state.nameCountry as {};
  public receivedBackEndCode: any = history.state.BackEndCode as {};
  utmParams:any = history.state.utmParams as {}
  public serviceIdResponse: number = 0;
  public isLoading: boolean = false;
  public isLoadingCalendar: boolean = false;
  public showCalendar: boolean = false;
  public ToSName: string = '';
  public workShopName: string = '';
  public advisorName: string = '';
  public makeName: string = '';
  public cityName: string = history.state.cityName;
  public cityId: number = history.state.cityId;
  public workShopId: number = 0;
  public serviceAdvisorAttention: ServiceAdvisorShedule[] = [];
  public serviceAdvisorBlockedSchedule: ServiceAdvisorBlockedSchedule[] = [];
  public unavaibleAdvisorHours: unavaibleAdvisorHours[] = [];
  public busyDates: any[] = [];
  public isOwnerOnSite: boolean = true;
  public userSearched: boolean = false;
  public date?;
  public time = '';
  public customerBasicData?: CustomerBasicData;
  public vehicleData?: VehicleData;
  public representativeData?: Representative;
  public vehicleBrand: string = '';
  public typesOfservice: typeOfService[] = [];

  public loadingrescheduler: boolean = false;
  public loadingSerchPlate: boolean = false;
  public slotDurations: string = '';
  //completas tus datos
  public isReschedule: boolean = false;

  public schedulerData: any[] = [];
  public scheduleId: any;
  public edited = false;
  public edited2 = false;
  public details = false;
  public userData;
  public representativeDatacountry;
  nameDocumentType: any = '';
  public bannerSuccesURL = '';
  public scheduleAppointmentURL = '';
  task: Task = {
    name: 'Indeterminate',
    completed: false,
    color: 'primary',
    subtasks: [
      { name: 'Primary', completed: false, color: 'primary' },
      { name: 'Accent', completed: false, color: 'accent' },
      { name: 'Warn', completed: false, color: 'warn' },
    ],
  };
  documentType!: DocumentType[];
  SelectYourService: string = 'Elige tu servicio';
  FinalizeReservationr: string = 'Finaliza tu reserva';
  CompleteData: string = 'Completa tus datos';
  public PlaceHolderObservations: string = '';
  public disclaimer: string = '';
  public tooltipService: string = '';
  public typeOfServiceIdSelect;
  selectOwnerOnSite: string = 'true';
  owner: boolean = true;
  public isNewUser = true;
  public TermAndConditiosMode: string = 'Default';
  timeSlotsIncadea!: ResponseTimeSlots[];
  departmentsSelect!: RespDeptMakes;
  makesSelect!: RespDeptMakes;
  servicesSelect!: ResponseServices;
  resourcesSelect!: ResponseResources;
  Departments: RespDeptMakes[] = []; 
  Makes: RespDeptMakes[] =[];
  tooltipDocumentType:string=""
  isTooltipVisible: boolean = false;
  isTooltipIconFilled: boolean = false;
  @ViewChild('tooltip') tooltip!: MatTooltip;
  Services$: Observable<ResponseServices[]> = new Observable<
    ResponseServices[]
  >();
  Services!: ResponseServices[];
  resources!: ResponseResources[];
  dataCreationAppointment!: AppointmentCreate;
  dataCreationAppointmentBooking!: ABappointment;
  LoadingHours: boolean = false;
  isLoadingData: boolean = false;
  indexbrand: number = 0;
  indexCountry: number = 0;
  getTermsAndCondition:termsAndConditions = {
    TermsConditionsId: 0,
    Title: '',
    Description: '',
    File: '',
    IsActive: true,
    ModificationDate: '',
    BrandId: 0,
    CountryId: 0,
    UrlAddress: '',
    Observations: '',
    DataProcessingPolicy: ''
  }
  
  public termsAndConditionsBrand:number = 0;
  constructor(
    private formBuilder: FormBuilder,
    public helperService: HelperService,
    public typesOfService: APIService,
    public WorkshopService: APIWorkshopService,
    public AdvisorsService: APIServiceAdvisorService,
    public customerBasicDataService: APICustomerBasicDataService,
    public vehicleDataService: VehicleDataService,
    public customScheduleService: APICustomScheduleService,
    public schedulerService: APISchedulerService,
    public customersBasicData: APICustomerBasicDataService,
    public representativeDataService: APIRepresentativeService,
    public cityServiceApi: APIcityService,
    public attetionSchedulerservice: APIAttentionSchedule,
    public AdvisorScheduleService: APIServiceAdvisorSchedule,
    public serviceAdvisorBlockedScheduleService: APIServiceAdvisorBlockedSchedule,
    public dealerBlockedScheduleService: APIBlockedAttentionSchedules,
    public DealerBlockedServices: APIDealerBlockedServices,
    public APIServiceAdvisorBlockedSchedule: APIServiceAdvisorBlockedSchedule,
    public APIServicetypeDocument: APIDocumentTypeService,
    private router: Router,
    private translate: TranslateService,
    public getDepartmentsService: GetDepartmentsService,
    public getMakesService: GetMakesService,
    public getServices: GetServicesService,
    public getResourcesService: GetResourcesService,
    public getTimeSlotsService: GetTimeSlotsService,
    public getAppointmentCreate: GetAppointmentCreate,
    public getCreateIncadeaBooking: IncadeaBookingService,
    public APITermsAndPolitics: APITermsAndPolitics,
    private route: ActivatedRoute,
    public cancelAppointmentSchedule: IncadeaBookingService,
    private sanitizer: DomSanitizer,

  ) {

    
    if (!this.recievedCountryData) {
      this.route.params.subscribe((params) => {
        this.indexbrand = params['brand'];
        this.indexCountry = params['country'];
      });
      const bannermanagementURL = `WebView/i-bannerManage/${this.indexbrand}/${this.indexCountry}`;
      this.router.navigate([bannermanagementURL]);
    }
    this.getTermAndConditions();
  }

  ngOnInit(): void {
    this.SelectForCountryTermAndConditions();
    this.isLoadingData = true;
    this.APIServicetypeDocument.GetByCountryId(this.recievedCountryData)
      .pipe(
        tap((response) => {
          if (!response.message) {
              this.documentType = response;
              if(Number(this.recievedCountryData) === 8){
                this.documentType.forEach((value,index) => {
                  if(index === 0){
                    this.tooltipDocumentType = this.tooltipDocumentType +value.typeName
                  }else{
                    this.tooltipDocumentType = this.tooltipDocumentType + ", "+value.typeName
                  }
                })
              }
              if (this.recievedScheduledData.AppointmentId !== '') {
                let docuemntName = this.documentType.filter(
                  (docuemet) =>
                    docuemet.typeId ===
                    Number(this.recievedScheduledData.DocumentTypeId)
                );
                if (docuemntName.length > 0) {
                  this.nameDocumentType = docuemntName[0].typeName;
                }
              }
          }
        })
      )
      .subscribe({
        error: (error) => {
          if(error.status === 401){
            const bannermanagementURL = `WebView/bannerManage/${this.indexbrand}/${this.indexCountry}`
            this.router.navigate([bannermanagementURL]);
            this.helperService.TokenBooking = ''
          }else{
            const translateTxtNotMatch = this.translate.instant('notMatchFound');
            this.helperService.showAlert =true
            this.helperService.typeAlert ="error"
            this.helperService.messageAlert =translateTxtNotMatch
            setTimeout(() => {
              this.helperService.showAlert =false
            }, 7000)
          }
          
        },
      });

    if (
      this.recievedScheduledData.AppointmentId !== '' &&
      this.receivedlocationSelect === undefined
    ) {
      //  console.log(this.recievedScheduledData)

      this.getdataOldAppointment();
      // this.loadingrescheduler = true
    } else if (this.recievedScheduledData.AppointmentId === '') {
      this.workShopName = this.receivedcompaniesSelect.Description;
      this.cityName = this.receivedlocationSelect.Description;
      this.getDateVehicle();
    } else {
      this.workShopName = this.receivedcompaniesSelect.Description;
      this.cityName = this.receivedlocationSelect.Description;
      this.getDateVehicle();
      this.getAppointmentReschudule();
    }
    this.traductionData();
    this.bannerSuccesURL = `WebView/i-bannerSuccess/${this.recievedBrand}/${this.recievedCountryData}`;
    this.scheduleAppointmentURL = `WebView/i-bannerManage/${this.recievedBrand}/${this.recievedCountryData}`;
  }

  @HostListener('window:scroll', [])
  onWindowScroll() {
    if (this.isTooltipVisible) {
      this.onIconClick('exclamation', 'bi-exclamation-circle', this.tooltip);
    }
  }

  getAppointmentReschudule() {
    this.formValidation2.patchValue({
      placa: this.recievedScheduledData.LicenseNo,
      cedula: this.recievedScheduledData.CustomerId,
      tip_Doc: Number(this.recievedScheduledData.DocumentTypeId),
      nombres: this.recievedScheduledData.CustomerName.split(' ')[0],
      apellidos: this.recievedScheduledData.CustomerName.split(' ')[1],
      celular: this.recievedScheduledData.CustomerPhoneNo,
      correo: this.recievedScheduledData.CustomerEmail,
      vin: this.recievedScheduledData.VIN,
    });

    this.selectOwnerOnSite =
      this.recievedScheduledData.IsCustomerPresent.toString();
    this.isOwnerOnSite = this.recievedScheduledData.IsCustomerPresent;
    if (this.recievedScheduledData.Representative) {
      this.formValidation_representative.patchValue({
        representativeDocumentType: Number(
          this.recievedScheduledData.Representative[0].DocumentType
        ),
        representativeDocumentNumber:
          this.recievedScheduledData.Representative[0].DocumentNumber,
        representativeName:
          this.recievedScheduledData.Representative[0].RepresentativeFullName.split(
            ' '
          )[0],
        representativeLastName:
          this.recievedScheduledData.Representative[0].RepresentativeFullName.split(
            ' '
          )[1],
        representativecorreo:
          this.recievedScheduledData.Representative[0].Email,
      });
    }
  }
  // Initial methods
  SelectForCountryTermAndConditions() {
    switch (Number(this.recievedCountryData)) {
      case 3:
        if (Number(this.recievedBrand) === 4) {
          this.TermAndConditiosMode = 'ChileGeely';
        }
        if (Number(this.recievedBrand) === 5) {
          this.TermAndConditiosMode = 'ChileSubaru';
        }
        if (Number(this.recievedBrand) === 6) {
          this.TermAndConditiosMode = 'ChileDfsk';
        }

        if (Number(this.recievedBrand) === 8) {
          this.TermAndConditiosMode = 'ChileDerco';
        }
        break;
      case 5:
        this.TermAndConditiosMode = 'Panama';
        this.tooltipService = this.translate.instant('ToolTipIncadeaPAM');
        break;

      case 6:
        this.tooltipService = this.translate.instant('ToolTipIncadeaCR');
        // costarica
        if (Number(this.recievedBrand) === 1) {
          this.TermAndConditiosMode = 'CostaricaSuzuki';
        }
        if (Number(this.recievedBrand) === 2) {
          this.TermAndConditiosMode = 'CostaricaChangan';
        }

        if (Number(this.recievedBrand) === 3) {
          this.TermAndConditiosMode = 'CostaricaJac';
        }

        break;

      case 8:
        this.TermAndConditiosMode = 'MercedezBenz';
        break;
    }
  }

  getTermAndConditions(){
    switch(Number(this.recievedBrand)){ 
      //SUSUKI
      case 1: 
      this.termsAndConditionsBrand = 14
      break;

      //CHANGAN
      case 2: 
      this.termsAndConditionsBrand = 13
      break;

      //JAC
      case 3: 
      this.termsAndConditionsBrand =10
      break;

      //GEELY
      case 4: 
      this.termsAndConditionsBrand = 21
      break;

      //SUBURU
      case 5: 
      this.termsAndConditionsBrand = 2
      break;

      //DFSK
      case 6: 
      this.termsAndConditionsBrand = 3
      break;

      //MERCEDES BENZ
      case 7: 
      this.termsAndConditionsBrand = 20
      break;

      //DERCO
      case 8: 
      this.termsAndConditionsBrand = 8
      break;
    }
    this.APITermsAndPolitics.termsAndPoliticsByBrandAndCountryId(this.termsAndConditionsBrand,Number (this.recievedCountryData))
    .pipe(tap(data=> {
      
      if(data !== null){
        this.getTermsAndCondition = data[0];
        if(this.getTermsAndCondition.Observations === null){     
          this.getTermsAndCondition.Observations = '';
        }
        if(this.getTermsAndCondition.Description === null){
          this.getTermsAndCondition.Description = '';
        }
        if(this.getTermsAndCondition.DataProcessingPolicy === null){
          this.getTermsAndCondition.DataProcessingPolicy = '';
        }
        if(this.getTermsAndCondition.UrlAddress === null){
          this.getTermsAndCondition.UrlAddress = '';
        }
      }else{
        this.getTermsAndCondition={
          TermsConditionsId: 0,
          Title: '',
          Description: '',
          File: '',
          IsActive: true,
          ModificationDate: '',
          BrandId: 0,
          CountryId: 0,
          UrlAddress: '',
          Observations: '',
          DataProcessingPolicy: ''
        }
      } 
     
      
    }),catchError((error: any) => {
      if (error.status === 401) { 
        const bannermanagementURL = `WebView/bannerManage/${this.indexbrand}/${this.indexCountry}`;
        this.router.navigate([bannermanagementURL]);
        this.helperService.TokenBooking = '';
      }else{
        // Handle validation error here
        console.error('Validation Error:', error);
        // Rethrow the error to propagate it downstream
        return throwError(error);
      }
      return of(null);
    }))
    .subscribe()
    
  }

  traductionData() {
    this.disclaimer = this.translate.instant('disclamermilegs');
    this.PlaceHolderObservations = this.translate.instant(
      'PlaceHolderObservations'
    );
    this.SelectYourService = this.translate.instant('SelectYourService');
    this.FinalizeReservationr = this.translate.instant('FinalizeReservationr');
    this.CompleteData = this.translate.instant('CompleteData');
    this.tooltipDocumentType = this.translate.instant('tooltipDocumentType')
  }
  // Get filters Booking
  getdataOldAppointment() {
    this.isReschedule = true;
    this.isNewUser = false;
    this.receivedcompaniesSelect = {
      Id: this.recievedScheduledData.CompanyId,
      Description: this.recievedScheduledData.CompanyName,
    };
    this.receivedlocationSelect = {
      Id: this.recievedScheduledData.LocationId,
      Description: this.recievedScheduledData.LocationName,
    };
    this.departmentsSelect = {
      Code: this.recievedScheduledData.Department,
      Id: '',
      Description: this.recievedScheduledData.Department,
    };
    this.makesSelect = {
      Code: this.recievedScheduledData.Make,
      Id: '',
      Description: this.recievedScheduledData.MakeName
      ,
    };
    this.filterDepartments(this.departmentsSelect)
    if(this.recievedBrand === '8'){this.filterMakes(this.makesSelect)}


    this.resourcesSelect = {
      Type: '',
      Id: this.recievedScheduledData.Resources[0].ResourceId,
      Code: '',
      Description: this.recievedScheduledData.Resources[0].ResourceName,
      Department: '',
    };

    this.servicesSelect = {
      Type: '',
      Id: this.recievedScheduledData.Services[0].ServiceId,
      Code: '',
      Description: this.recievedScheduledData.Services[0].ServiceName,
      Name: this.recievedScheduledData.Services[0].ServiceName,
      DescriptionLong: '',
      Note: '',
      Department: this.recievedScheduledData.Department,
      Category: '',
      Duration: this.recievedScheduledData.Duration,
    };

    this.filterResources(this.resourcesSelect);
    this.getDateVehicle();
    this.workShopName = this.receivedcompaniesSelect.Description;
    this.cityName = this.receivedlocationSelect.Description;
    this.ToSName = this.servicesSelect.Name;

    this.formValidation.patchValue({
      tip_service: this.recievedScheduledData.Services[0].ServiceId,
      observations: this.recievedScheduledData.Comment,
      asesor: this.recievedScheduledData.Resources[0].ResourceId,
      makeCar: this.recievedScheduledData.Make,
      typeCar: this.recievedScheduledData.Department,
      kilometraje: this.recievedScheduledData.Mileage,
    });

    this.formValidation2.patchValue({
      placa: this.recievedScheduledData.LicenseNo,
      cedula: this.recievedScheduledData.CustomerId,
      tip_Doc: Number(this.recievedScheduledData.DocumentTypeId),
      nombres: this.recievedScheduledData.CustomerName.split(' ')[0],
      apellidos: this.recievedScheduledData.CustomerName.split(' ')[1],
      celular: this.recievedScheduledData.CustomerPhoneNo,
      correo: this.recievedScheduledData.CustomerEmail,
      vin: this.recievedScheduledData.VIN,
    });

    this.selectOwnerOnSite =
      this.recievedScheduledData.IsCustomerPresent.toString();
    this.isOwnerOnSite = this.recievedScheduledData.IsCustomerPresent;
    if (this.recievedScheduledData.Representative) {
      this.formValidation_representative.patchValue({
        representativeDocumentType: Number(
          this.recievedScheduledData.Representative[0].DocumentType
        ),
        representativeDocumentNumber:
          this.recievedScheduledData.Representative[0].DocumentNumber,
        representativeName:
          this.recievedScheduledData.Representative[0].RepresentativeFullName.split(
            ' '
          )[0],
        representativeLastName:
          this.recievedScheduledData.Representative[0].RepresentativeFullName.split(
            ' '
          )[1],
        representativecorreo:
          this.recievedScheduledData.Representative[0].Email,
      });
    }

    // this.serchrepresentrative()
  }

  getDateVehicle() {
    this.getDepartmentsService
      .getDepartments(
        this.receivedTokenIncadea,
        this.receivedcompaniesSelect.Id,
        this.receivedBackEndCode
      )
      .pipe(
        tap((Departemnt) => {
          this.getMakesService
            .getMakes(
              this.receivedTokenIncadea,
              this.receivedcompaniesSelect.Id,
              this.receivedBackEndCode
            )
            .pipe(
              tap((makes) => {
                let filteredMakes = makes; // Create a copy of the original array

                switch (this.recievedBrand) {
                  case '1':
                    filteredMakes = makes.filter(
                      (make) => make.Code.toLowerCase() === 'suzuki'
                    );
                    break;

                  case '2':
                    filteredMakes = makes.filter(
                      (make) => make.Code.toLocaleLowerCase() === 'changan'
                    );
                    break;

                  case '3':
                    filteredMakes = makes.filter(
                      (make) => make.Code.toLocaleLowerCase() === 'jac'
                    );
                    break;

                  case '4':
                    filteredMakes = makes.filter(
                      (make) => make.Code.toLowerCase() === 'geely'
                    );
                    break;

                  case '5':
                    filteredMakes = makes.filter(
                      (make) => make.Code.toLocaleLowerCase() === 'subaru'
                    );
                    break;

                  case '6':
                    filteredMakes = makes.filter(
                      (make) => make.Code.toLocaleLowerCase() === 'dfsk'
                    );
                    break;
                  case '7':
                    filteredMakes = makes.filter(
                      (make) => make.Code.toLocaleLowerCase() === 'mb'
                    );
                    break;
                    case '8':
                    let MakesDerco = makes
                    MakesDerco.forEach((make,index) =>{

                      // if(make.Code.toLocaleLowerCase() === 'subaru' &&  make.Code.toLowerCase() !== 'geely'&&  make.Code.toLocaleLowerCase() !== 'dfsk')
                      if(make.Code.toLocaleLowerCase() === 'suzuki' ||  make.Code.toLowerCase() === 'mazda')
                        {
                         this.Makes[this.Makes.length]= make;
                        }
                    }
                  )
                  filteredMakes = this.Makes.filter(
                    (make) => make.Code.toLocaleLowerCase() === this.recievedScheduledData.MakeName.toLocaleLowerCase()

                  );
                  this.formValidation.patchValue({
                    makeCar: filteredMakes[0].Code,
                  });
                  this.makesSelect = filteredMakes[0]

                  this.makeName = this.makesSelect.Description
                    break;


                  default:
                    filteredMakes = makes;
                }
                if (filteredMakes.length === 1 && this.recievedBrand !== '8') {
                  this.makesSelect = filteredMakes[0];
                  this.formValidation.patchValue({
                    makeCar: this.makesSelect.Code,
                  });
                }
                this.isLoadingData = false;

                //this IF filters the types of services for Chile country
                if(Number(this.recievedCountryData)=== 3){
                  
                  switch(this.recievedBrand){
                    
                    case '4': //Geely
                    if(this.receivedlocationSelect.Description === "Av. Sta. Rosa 555, Santiago, Región Metropolitana"){
                      Departemnt.forEach((make) =>{
                        if( make.Description.toLocaleLowerCase() === 'mantencion programada' ||  make.Description.toLowerCase() === 'mecanica general' ||  make.Description.toLowerCase() === 'recall' ||  make.Description.toLowerCase() === 'diagnostico 25 puntos' || make.Description.toLowerCase() === 'desabolladura y pintura')
                          {
                           this.Departments[this.Departments.length]= make;
                          }
                      })
                    }
                    break;
                    
                    case '5': //Subaru
                    if(this.receivedlocationSelect.Description === "Av. Sta. Rosa 555, Santiago, Región Metropolitana" || "Av. Las Condes 10740, Vitacura, Región Metropolitana"){
                      Departemnt.forEach((make) =>{
                        if( make.Description.toLocaleLowerCase() === 'mantencion programada' ||  make.Description.toLowerCase() === 'mecanica general' ||  make.Description.toLowerCase() === 'recall' ||  make.Description.toLowerCase() === 'diagnostico 25 puntos' || make.Description.toLowerCase() === 'desabolladura y pintura')
                          {
                           this.Departments[this.Departments.length]= make;
                          }
                      })
                    }
                    break;

                    case '6': //DFSK
                    if(this.receivedlocationSelect.Description === "Av. Gral. Bustamante 638, Ñuñoa, Región Metropolitana"){
                      Departemnt.forEach((make) =>{
                        if( make.Description.toLocaleLowerCase() === 'mantencion programada' ||  make.Description.toLowerCase() === 'mecanica general' ||  make.Description.toLowerCase() === 'recall' ||  make.Description.toLowerCase() === 'diagnostico 25 puntos' || make.Description.toLowerCase() === 'desabolladura y pintura')
                          {
                           this.Departments[this.Departments.length]= make;
                          }
                      })
                    }
                    break;

                    case '8': //Derco
                      if(this.receivedlocationSelect.Description === "Av.Tabancura 1359, Vitacura"){
                        Departemnt.forEach((make) =>{
                          if( make.Description.toLocaleLowerCase() === 'mantencion programada' ||  make.Description.toLowerCase() === 'mecanica general' ||  make.Description.toLowerCase() === 'recall' ||  make.Description.toLowerCase() === 'mantencion flexible' || make.Description.toLowerCase() === 'instalacion accesorios')
                            {
                             this.Departments[this.Departments.length]= make;
                            }
                        })
                      }

                    break;
                  }
                } else{
                  
                  this.Departments = Departemnt;
                }
                
              })
            )
            .subscribe();
        })
      )
      .subscribe();
  }

  onPlateNumberSearchClick() {
    // reset fields
    this.edited = false;
    this.edited2 = false;
    this.isNewUser = true;
    this.loadingSerchPlate = true;
    this.formValidation2.patchValue({
      tip_Doc: 0,
      nombres: '',
      apellidos: '',
      celular: '',
      correo: '',
      vin: '0',
      terms: false,
      politics: false,
      cedula:this.cedulaControl.value
    });
    this.vehicleDataService
      .getValidatedData(this.placaControl.value, this.cedulaControl.value)
      .pipe(
        tap((response) => {
          this.userSearched = true;
          if (response !== null) {
            this.userData = response;

            if (this.documentType) {
              let docuemntName = this.documentType.filter(
                (docuemet) => docuemet.typeId === this.userData[0].typeId
              );
              if (docuemntName.length > 0) {
                this.nameDocumentType = docuemntName[0].typeName;
              }
            }

            this.isNewUser = false;
            this.isReschedule = false;
            this.edited = true;
            this.edited2 = true;
            this.loadingSerchPlate = false;
            this.formValidation2.patchValue({
              cedula: this.userData[0].identification,
              tip_Doc: this.userData[0].typeId,
              nombres: this.userData[0].firstName,
              apellidos: this.userData[0].lastName,
              celular: this.userData[0].phone,
              correo: this.userData[0].email,
              vin: this.userData[0].vin,
              terms: false,
              politics: false,
            });
            this.representativeDataService
              .getForCustomerId(this.userData[0].customerId)
              .pipe(
                tap((response) => {
                  if (!response.message) {
                    this.representativeDatacountry = response;
                    this.formValidation_representative.patchValue({
                      representativeDocumentNumber:
                        this.representativeDatacountry.identification,
                      representativeName:
                        this.representativeDatacountry.firstName,
                      representativeLastName:
                        this.representativeDatacountry.lastName,
                      representativePhone: this.representativeDatacountry.phone,
                      representativeCountryCode: '57',
                      representativeDocumentType:
                        this.representativeDatacountry.documentType,
                      representativecorreo:
                        this.representativeDatacountry.email,
                    });
                  } else {
                    this.representativeDatacountry = { representativeId: 0 };
                    this.formValidation_representative.patchValue({
                      representativeDocumentNumber: '',
                      representativeName: '',
                      representativeLastName: '',
                      representativePhone: '',
                      representativeCountryCode: '',
                    });
                  }
                })
              )
              .subscribe();
            this.loadingSerchPlate = false;
          } else {
            // this.userData[0]=[{vehicleId : 0,customerId : 0}]
            this.userData = [{ vehicleId: 0, customerId: 0 }];
            this.representativeDatacountry = { representativeId: 0 };

            this.formValidation2.patchValue({
              tip_Doc: 0,
              nombres: '',
              apellidos: '',
              celular: '',
              correo: '',
              vin: '',
              terms: false,
              politics: false,cedula:this.cedulaControl.value
            });
          }
          this.loadingSerchPlate = false;
          this.details = true;
        })
      )
      .subscribe({
        error: (error) => {
          if(error.status === 401){
            const bannermanagementURL = `WebView/bannerManage/${this.indexbrand}/${this.indexCountry}`
            this.router.navigate([bannermanagementURL]);
            this.helperService.TokenBooking = ''
          }else{
            console.log(error);
            const translateTxtNotMatch =
              this.translate.instant('error');
              this.helperService.showAlert =true
              this.helperService.typeAlert ="error"
              this.helperService.messageAlert =translateTxtNotMatch
              setTimeout(() => {
                this.helperService.showAlert =false
              
                }, 7000)
            this.loadingSerchPlate = false;
          }
        }  
      });
  }

  serchrepresentrative() {
    this.vehicleDataService
      .getValidatedData(
        this.recievedScheduledData.LicenseNo,
        this.recievedScheduledData.CustomerId
      )
      .pipe(
        tap((response) => {
          if (!response.message) {
            this.userData = response;

            this.representativeDataService
              .getForCustomerId(this.userData[0].customerId)
              .pipe(
                tap((response) => {
                  if (!response.message) {
                    this.representativeDatacountry = response;
                    this.formValidation_representative.patchValue({
                      representativeDocumentNumber:
                        this.representativeDatacountry.identification,
                      representativeName:
                        this.representativeDatacountry.firstName,
                      representativeLastName:
                        this.representativeDatacountry.lastName,
                      representativePhone: this.representativeDatacountry.phone,
                      representativeCountryCode: '57',
                      representativeDocumentType:
                        this.representativeDatacountry.documentType,
                      representativecorreo:
                        this.representativeDatacountry.email,
                    });
                  } else {
                    this.representativeDatacountry = { representativeId: 0 };
                    this.formValidation_representative.patchValue({
                      representativeDocumentNumber: '',
                      representativeName: '',
                      representativeLastName: '',
                      representativePhone: '',
                      representativeCountryCode: '',
                    });
                  }
                })
              )
              .subscribe({
                error: () => {
                  const translateTxtNotMatch =
                    this.translate.instant('notMatchFound');
                    this.helperService.showAlert =true
                    this.helperService.typeAlert ="error"
                    this.helperService.messageAlert =translateTxtNotMatch
                    setTimeout(() => {
                      this.helperService.showAlert =false
                    
                      }, 7000)
                },
              });
          } else {
            // this.userData[0]=[{vehicleId : 0,customerId : 0}]
            this.userData = [{ vehicleId: 0, customerId: 0 }];
            this.representativeDatacountry = { representativeId: 0 };

            // this.formValidation2.patchValue({
            //   tip_Doc: 0,
            //   nombres: '',
            //   apellidos: '',
            //   celular: '',
            //   correo: '',
            //   vin: '',
            //   terms: false,
            //   politics: false,
            // });
          }
        })
      )
      .subscribe({
        error: (error) => {
          if(error.status === 401){
            const bannermanagementURL = `WebView/bannerManage/${this.indexbrand}/${this.indexCountry}`
            this.router.navigate([bannermanagementURL]);
            this.helperService.TokenBooking = ''
          }else{
            const translateTxtNotMatch = this.translate.instant('notMatchFound');
            this.helperService.showAlert =true
            this.helperService.typeAlert ="success"
            this.helperService.messageAlert =translateTxtNotMatch
            setTimeout(() => {
              this.helperService.showAlert =false
          
            }, 7000)
          }
        },
      });
  }

  // Get filters dinamic Incadea
  filterDepartments(departments: RespDeptMakes) {
  //  if(this.recievedBrand !== '8'){
    this.isLoadingData = true;
    this.departmentsSelect = departments;
    this.resetForchangeDepartament();

    this.getServices
      .getServices(
        this.receivedTokenIncadea,
        this.receivedcompaniesSelect.Id,
        this.receivedlocationSelect.Id,
        this.departmentsSelect.Code,
        this.makesSelect.Code,
        this.receivedBackEndCode
      )
      .pipe(
        tap((response) => {
          this.Services = response.filter(
            (service) => service.Department === this.departmentsSelect.Code
          );
          this.getResourcesService
            .getResources(
              this.receivedTokenIncadea,
              this.receivedcompaniesSelect.Id,
              this.receivedlocationSelect.Id,
              this.receivedBackEndCode,
              this.departmentsSelect.Code
            )
            .pipe(
              tap((response) => {
                this.resources = response.filter(
                  (service) => service.Type === 'ServiceAdvisor'
                );
                this.isLoadingData = false;
              })
            )
            .subscribe();
        })
      )
      .subscribe();
    // }else{ this.departmentsSelect = departments;}
  }
  filterMakes(Makes: RespDeptMakes){
    this.isLoadingData = true;
    this.makesSelect = Makes
    this.makeName = Makes.Description


    this.resetForchangeDepartament();

    this.getServices
      .getServices(
        this.receivedTokenIncadea,
        this.receivedcompaniesSelect.Id,
        this.receivedlocationSelect.Id,
        this.departmentsSelect.Code,
        this.makesSelect.Code,
        this.receivedBackEndCode
      )
      .pipe(
        tap((response) => {
          this.Services = response.filter(
            (service) => service.Department === this.departmentsSelect.Code
          );
          this.getResourcesService
            .getResources(
              this.receivedTokenIncadea,
              this.receivedcompaniesSelect.Id,
              this.receivedlocationSelect.Id,
              this.receivedBackEndCode,
              this.departmentsSelect.Code
            )
            .pipe(
              tap((response) => {
                this.resources = response.filter(
                  (service) => service.Type === 'ServiceAdvisor'
                );
                this.isLoadingData = false;
              })
            )
            .subscribe();
        })
      )
      .subscribe();
  }
  filterservice(service: ResponseServices) {
    this.servicesSelect = service;
    this.ToSName = this.servicesSelect.Name;
    this.showCalendar = false;
  }
  filterResources(resource: ResponseResources) {
    this.resourcesSelect = resource;
    this.advisorName = resource.Description;
    this.showCalendar = false;
    setTimeout(() => {
      this.showCalendar = true;
    }, 1);

    // this.GetTimeSlotsService(('0' + (new Date().getMonth() + 1)).slice(-2),new Date().getFullYear())
  }

  // create appointment
TokenCatcha:string=""
  ejecutarCaptcha() {
      grecaptcha.ready(() => {
      grecaptcha.execute(this.helperService.siteKeyCatcha, { action: 'login' }).then((token: string) => {
        this.TokenCatcha = token
        
        this.onSave();
        // Enviar token al backend
      });
    });
  }
  onSave() {
    this.isLoading = true;
    // console.log(this.recievedScheduledData)
    if (this.recievedScheduledData.AppointmentId !== '') {
      this.getAppointmentCreate
        .cancelAppointmnet(
          this.receivedTokenIncadea,
          this.receivedcompaniesSelect.Id,
          this.recievedScheduledData.AppointmentId,
          this.receivedBackEndCode
        )
        .subscribe({next:(response) => {

          if (response.status === 200) {
            // console.log(this.createApointmentincadea())
            this.getAppointmentCreate
              .postAppointmnet(
                this.receivedTokenIncadea,
                this.receivedcompaniesSelect.Id,
                this.createApointmentincadea(),
                this.receivedBackEndCode
              )
              .pipe(
                tap((response) => {
                  if (response.AppointmentId) {
                    this.createApointmentBooking(response, 'Edit');
                    // console.log(response,"incadea")
                  }
                }),
                catchError((error): Observable<any> => {
                  console.error('Error:', error);
                  const translateTextError = this.translate.instant(
                    'ToastErrorAppointment'
                  );
                  this.helperService.showAlert =true
                  this.helperService.typeAlert ="error"
                  this.helperService.messageAlert =translateTextError
                  setTimeout(() => {
                    this.helperService.showAlert =false
                  
                  }, 7000)
                  return error;
                })
              )
              .subscribe();
          }

          if (
            response.status === 400 ||
            response.status === 500 ||
            response.status === 1074
          ) {
            console.error(response, 'cita no cancelada');
            const translateTextError = this.translate.instant(
              'ToastErrorAppointment'
            );
            this.helperService.showAlert =true
            this.helperService.typeAlert ="error"
            this.helperService.messageAlert =translateTextError
            setTimeout(() => {
              this.helperService.showAlert =false
            
            }, 7000)
          }
        },error: (failed) => {

          if(failed.error.Detail ==="The appointment has already been canceled"){
            this.cancelAppointmentSchedule.cancelAppointment(this.recievedScheduledData.AppointmentId).subscribe(
              {
                error: (failed) => {
                  if (failed.status === 401) { 
                    const bannermanagementURL = `WebView/bannerManage/${this.indexbrand}/${this.indexCountry}`;
                    this.router.navigate([bannermanagementURL]);
                    this.helperService.TokenBooking = '';
                  }else{
                    let mensageError = failed.error.text
                  const translateTextError = this.translate.instant(
                    'ToastErrorCancelIncadea'
                  );
                  this.helperService.showAlert =true
                  this.helperService.typeAlert ="error"
                  this.helperService.messageAlert =translateTextError
                  setTimeout(() => {
                    this.helperService.showAlert =false
                    }, 7000)
                  setTimeout(() => {
                    this.route.params.subscribe((params) => {
                      this.indexbrand = params['brand'];
                      this.indexCountry = params['country'];
                    });
                    const bannermanagementURL = `WebView/i-bannerManage/${this.indexbrand}/${this.indexCountry}`;
                    this.router.navigate([bannermanagementURL]);
                  }, 5000);

                  } 
                },
              }
            )
          }
          else{
            console.error("Error al cancelar",failed)

          }


        }});
    } else {
      // getCreateIncadeaBooking
      //  console.log(this.createApointmentincadea())
      this.getAppointmentCreate
        .postAppointmnet(
          this.receivedTokenIncadea,
          this.receivedcompaniesSelect.Id,
          this.createApointmentincadea(),
          this.receivedBackEndCode
        )
        .pipe(
          tap((response) => {
            if (response.AppointmentId) {
              this.createApointmentBooking(response, 'New');
              // console.log(response,"incadea")
            }
          }),
          catchError((error): Observable<any> => {
            console.error('Error:', error);
            const translateTextError = this.translate.instant(
              'ToastErrorAppointment'
            );
            this.helperService.showAlert =true
            this.helperService.typeAlert ="error"
            this.helperService.messageAlert =translateTextError
            setTimeout(() => {
              this.helperService.showAlert =false
            
            }, 7000)

            return error;
          })
        )
        .subscribe();
    }
  }
  createApointmentincadea() {
    let DateFormat = this.date.split('/');
    DateFormat = `${DateFormat[2]}-${DateFormat[1]}-${DateFormat[0]}`;
    let TimeFormat = moment(this.time, ['h:mm A']).format('HH:mm:ss');
    let limitDate =
      new Date().getFullYear() +
      '-' +
      ('0' + (new Date().getMonth() + 6)).slice(-2) +
      '-' +
      '15' +
      'T23:59:00';
    if (new Date().getMonth() + 6 > 12) {
      limitDate =
        new Date().getFullYear() +
        1 +
        '-' +
        ('0' + (new Date().getMonth() + 6 - 12)).slice(-2) +
        '-' +
        '15' +
        'T23:59:00';
    }

    const dataCustomer = {
      Name:
        String(this.formValidation2.value.nombres) +
        ' ' +
        String(this.formValidation2.value.apellidos),
      Phone: {
        PhoneNo: String(this.formValidation2.value.celular),
        Type: 'Business',
      },
      Email: {
        Email: String(this.formValidation2.value.correo),
        Type: 'Business',
      },
    };

    const DataPrivacyConsent = [
      {
        Beneficiary: this.departmentsSelect.Description,
        Purpose: {
          Type: 'Business',
          CommunicationChannels: ['Post'],
        },
        Description: String(this.formValidation.value.observations),
        ExpirationDate: limitDate,
        CreatedOn:
          new Date().getFullYear() +
          '-' +
          ('0' + (new Date().getMonth() + 1)).slice(-2) +
          '-' +
          ('0' + new Date().getDate()).slice(-2) +
          'T' +
          ('0' + new Date().getHours()).slice(-2) +
          ':' +
          ('0' + new Date().getMinutes()).slice(-2) +
          ':' +
          ('0' + new Date().getSeconds()).slice(-2),
      },
    ];

    const dataVehicle = {
      Vin: this.isNewUser ? '' : String(this.formValidation2.value.vin),
      LicenseNo: String(this.formValidation2.value.placa),
      Make: this.makesSelect.Code,
      Department: this.departmentsSelect.Code,
    };

    this.dataCreationAppointment = {
      LocationId: this.receivedlocationSelect.Id,
      Vehicle: dataVehicle,
      Customer: dataCustomer,
      TimeslotFrom: DateFormat + 'T' + TimeFormat,
      PreferredPaymentMethod: 'EF',
      Comment: String(this.formValidation.value.observations),
      ResourceIds: [this.resourcesSelect.Id],
      services: [{ Id: this.servicesSelect.Id }],
      DataPrivacyConsent: DataPrivacyConsent,
    };

    return this.dataCreationAppointment;
  }
  createApointmentBooking(response: ResponseAppointment, Mode) {
    let DateFormat = this.date.split('/');
    DateFormat = `${DateFormat[2]}-${DateFormat[1]}-${DateFormat[0]}`;
    let TimeFormat = moment(this.time, ['h:mm A']).format('HH:mm:ss');
    let limitDate =
      new Date().getFullYear() +
      '-' +
      ('0' + (new Date().getMonth() + 6)).slice(-2) +
      '-' +
      '15' +
      'T23:59:00';
    if (new Date().getMonth() + 6 > 12) {
      limitDate =
        new Date().getFullYear() +
        1 +
        '-' +
        ('0' + (new Date().getMonth() + 6 - 12)).slice(-2) +
        '-' +
        '15' +
        'T23:59:00';
    }
    let ownerOnsiteInNumber;
    const dataVehicle = {
      VIN: this.isNewUser ? '' : String(this.formValidation2.value.vin),
      LicenseNo: String(this.formValidation2.value.placa),
      Make: this.makesSelect.Code,
      Department: this.departmentsSelect.Code,
      MakeName: this.makesSelect.Description,
      DepartmentName: this.departmentsSelect.Description,
      RelationshipVehicle: '1',
      Mileage: String(this.formValidation.value.kilometraje),
    };
    const dataCustomer = {
      CustomerId: String(this.formValidation2.value.cedula),
      DocumentTypeId: String(this.formValidation2.value.tip_Doc),
      Name:
        String(this.formValidation2.value.nombres) +
        ' ' +
        String(this.formValidation2.value.apellidos),
      Phone: {
        PhoneNo: String(this.formValidation2.value.celular),
        Type: 'Business',
      },
      Email: {
        Email: String(this.formValidation2.value.correo),
        Type: 'Business',
      },
      IsCustomerPresent: this.isOwnerOnSite ? '1' : '0',
    };
    const dataRepresentative = {
      DocumentNumber: String(
        this.formValidation_representative.value.representativeDocumentNumber
      ),
      DocumentType: String(
        this.formValidation_representative.value.representativeDocumentType
      ),
      RepresentativeFullName:
        String(this.formValidation_representative.value.representativeName) +
        ' ' +
        String(this.formValidation_representative.value.representativeLastName),
      Email: String(
        this.formValidation_representative.value.representativecorreo
      ),
    };

    const DataPrivacyConsent = [
      {
        Beneficiary: this.departmentsSelect.Description,
        Purpose: {
          Type: 'Business',
          CommunicationChannels: ['Post'],
        },
        Description: String(this.formValidation.value.observations),
        ExpirationDate: limitDate,
        CreatedOn:
          new Date().getFullYear() +
          '-' +
          ('0' + (new Date().getMonth() + 1)).slice(-2) +
          '-' +
          ('0' + new Date().getDate()).slice(-2) +
          'T' +
          ('0' + new Date().getHours()).slice(-2) +
          ':' +
          ('0' + new Date().getMinutes()).slice(-2) +
          ':' +
          ('0' + new Date().getSeconds()).slice(-2),
      },
    ];

    this.dataCreationAppointmentBooking = {
      AppointmentId: response.AppointmentId,
      DocumentNo: response.DocumentNo,
      CompanyId: this.receivedcompaniesSelect.Id,
      CompanyName: this.receivedcompaniesSelect.Description,
      LocationName: this.receivedlocationSelect.Description,
      LocationId: this.receivedlocationSelect.Id,
      CountryId: String(this.recievedCountryData),
      UserId: String(0),
      Vehicle: dataVehicle,
      Customer: dataCustomer,
      Representative: dataRepresentative,
      TimeslotFrom: DateFormat + 'T' + TimeFormat,
      Duration: this.slotDurations,
      PreferredPaymentMethod: 'EF',
      Comment: String(this.formValidation.value.observations),
      SchedulerStatusId: String(1),
      CountryName: this.receivedNameCountry,
      ResourceIds: [
        {
          ResourceId: this.resourcesSelect.Id,
          ResourceName: this.resourcesSelect.Description,
        },
      ],
      Services: [
        { ServiceName: this.servicesSelect.Name, Id: this.servicesSelect.Id },
      ],
      DataPrivacyConsent: DataPrivacyConsent,
      UtmSource: this.utmParams.UtmSource ,
      UtmCampaign: this.utmParams.UtmCampaign ,
      UtmMedium: this.utmParams.UtmMedium ,
      UtmContent: this.utmParams.UtmContent ,
      UtmTerm: this.utmParams.UtmTerm,
      // utmDTO: this.utmParams
      RecaptchaToken:this.TokenCatcha
    };

    //  console.log(this.dataCreationAppointmentBooking)
    if (Mode === 'New') {
      this.getCreateIncadeaBooking
        .createIBAppointment(this.dataCreationAppointmentBooking)
        .pipe(
          tap((response) => {

            if (response.message === 'Appointment Created Successfully') {
              this.isLoading = false;
              //  console.log(response,"Booking",response.data[0])
              response.data[0].event = 'ServiceBooking_Lead';
              this.router.navigate([this.bannerSuccesURL], {
                state: { AppointmentInfo: response.data[0] },
              });
            }
          }),
          catchError((error): Observable<any> => {
            if (error.status === 401) { 
              const bannermanagementURL = `WebView/bannerManage/${this.indexbrand}/${this.indexCountry}`;
              this.router.navigate([bannermanagementURL]);
              this.helperService.TokenBooking = '';
            }else{
              console.error('Error:', error);
              const translateTextError = this.translate.instant('ToastErrorAppointment');
              this.helperService.showAlert =true
              this.helperService.typeAlert ="error"
              this.helperService.messageAlert =translateTextError
              setTimeout(() => {
                this.helperService.showAlert =false
            
              }, 7000)
            }
            return error; 
          })
        )
        .subscribe();
    }

    if (Mode === 'Edit') {

      this.dataCreationAppointmentBooking.SchedulerStatusId = String(4);
      this.getCreateIncadeaBooking
        .upDateIBAppointment(
          this.dataCreationAppointmentBooking,
          this.recievedScheduledData.AppointmentId
        )
        .pipe(
          tap((response) => {

            if (response.message === 'Appointment Updated Successfully.') {
              this.isLoading = false;

              //  console.log(response,"Booking Edit ")
              this.router.navigate([this.bannerSuccesURL], {
                state: { AppointmentInfo: "rescheduler Appintment"},
              });
            }
          }),
          catchError((error): Observable<any> => {
            
            if (error.status === 401) { 
              const bannermanagementURL = `WebView/bannerManage/${this.indexbrand}/${this.indexCountry}`;
              this.router.navigate([bannermanagementURL]);
              this.helperService.TokenBooking = '';
            }else{
              console.error('Error:', error);
              const translateTextError = this.translate.instant('ToastErrorAppointment');
              this.helperService.showAlert =true
              this.helperService.typeAlert ="success"
              this.helperService.messageAlert =translateTextError
              setTimeout(() => {
                this.helperService.showAlert =false
              
                }, 7000)
            }
            return error;
          })
        )
        .subscribe();
    }
  }

  // Secondary metods
  formsValidations(): boolean {
    if (this.isOwnerOnSite) {
      return this.formValidation2.invalid;
    } else {
      if (this.formValidation2.invalid) {
        return true;
      } else {
        return this.formValidation_representative.invalid;
      }
    }
  }

  resetForchangeDepartament() {
    this.formValidation.value.asesor = '';
    this.formValidation.value.tip_service = '';
    this.asesorControl.setValue('');
    this.tip_serviceControl.setValue('');
    this.advisorName = '';
    this.ToSName = '';
    this.time = '';
    this.date = '';
    this.showCalendar = false;
  }
  daysForMonthNow(year, mounth, day) {
    var date = new Date(year + '/' + mounth + '/' + day);
    return new Date(date.getFullYear(), date.getMonth() + 1, 0).getDate();
  }
  onIconMouseHoverAndOut(
    elementId: string,
    className: string,
    isFill: boolean
  ) {
    if (isFill) {
      document.getElementById(elementId)?.classList.add(className + '-fill');
      document.getElementById(elementId)?.classList.remove(className);
    } else {
      document.getElementById(elementId)?.classList.add(className);
      document.getElementById(elementId)?.classList.remove(className + '-fill');
    }
  }
  onIconClick(
    elementId: string,
    className: string,
    tooltip: MatTooltip
  ){
    this.isTooltipVisible = !this.isTooltipVisible;
    const element = document.getElementById(elementId);
    if (element){
      this.isTooltipIconFilled = !this.isTooltipIconFilled;
      tooltip.toggle();

      this.onIconMouseHoverAndOut(elementId, className, this.isTooltipIconFilled)
    }
  }
  backInitialChoose() {
    this.router.navigate([this.scheduleAppointmentURL]);
  }
  isNewSchedule(): boolean {
    return this.recievedScheduledData.AppointmentId === '';
  }
  toBoolean(event) {
    const value = event.target.value;
    this.isOwnerOnSite = value === 'true';
  }

  nextDisabled(): boolean {
    if (
      this.date === undefined ||
      this.date === '' ||
      this.time === '' ||
      this.formValidation.invalid
    ) {
      return true;
    } else return false;
  }
  transformInput({ target }) {
    target.value = target.value.toUpperCase().replace(/\s/g, '');
  }
  isOwner(e) {
    if (e.target.value === 'false') {
      this.owner = false;
    } else {
      this.owner = true;
    }
  }
  OwnerOnSite(e: any) {
    this.isOwnerOnSite = e.value === 'true';
  }

  timeValue(e) {
    this.time = e;
  }
  dateValue(e) {
    this.date = e;
  }
  slotDuration(e) {
    this.slotDurations = e;
  }
  SerchPlate(): boolean {
    if (
      String(this.formValidation2.value.placa) !== '' &&
      String(this.formValidation2.value.cedula) !== ''
    ) {
      return false;
    } else {
      return true;
    }
  }

  NameDocument(document: any) {
    this.nameDocumentType = document.typeName;
  }

  // user validations

  formValidation = this.formBuilder.group({
    typeCar: ['', Validators.required],
    makeCar: ['', Validators.required],
    tip_service: ['', Validators.required],
    observations: [''],
    kilometraje: [
      '',
      {
        validators: [Validators.required, Validators.pattern(/^([0-9])*$/)],
      },
    ],

    asesor: ['', Validators.required],
  });

  firstFormGroup = this.formBuilder.group({
    firstCtrl: ['', Validators.required],
    tip_service: ['', Validators.required],
    kilometraje: [
      '',
      {
        validators: [Validators.required, Validators.pattern(/^([0-9])*$/)],
      },
    ],
    asesor: ['', Validators.required],
  });

  formValidation2 = this.formBuilder.group({
    placa: ['', Validators.required],
    cedula: ['', [Validators.required, Validators.minLength(5)]],
    tip_Doc: [0, Validators.required],
    nombres: ['', [Validators.required, noSpecialCharsValidator]],
    apellidos: ['', [Validators.required, noSpecialCharsValidator]],
    cod_pais: [''],
    celular: [
      '',
      [Validators.required, noSpecialCharsValidator, Validators.minLength(5)],
    ],
    correo: [
      '',
      [Validators.required, emailValidator, noSpecialCharsValidator],
    ],
    vin: [''],
    terms: [false, Validators.requiredTrue],
    politics: [false, Validators.requiredTrue],
    isOwnerOnSite: [null, Validators.required],
  });

  formValidation_representative = this.formBuilder.group({
    representativeDocumentType: [0, Validators.required],
    representativeDocumentNumber: [
      '',
      {
        validators: [
          Validators.required,
          Validators.pattern(/^[a-zA-Z0-9\-]*$/),
          Validators.minLength(5),
        ],
      },
    ],
    representativeName: ['', [Validators.required, noSpecialCharsValidator]],
    representativeLastName: [
      '',
      [Validators.required, noSpecialCharsValidator],
    ],
    representativeCountryCode: [''],
    representativePhone: [
      '',
      [Validators.required, noSpecialCharsValidator, Validators.minLength(5)],
    ],
    representativecorreo: [
      '',
      [Validators.required, emailValidator, noSpecialCharsValidator],
    ],
    representativeRelationWithOwner: ['', Validators.required],
    canTakeDecision: [false],
  });

  //used for validation purposes
  get cedulaControl(): FormControl {
    return this.formValidation2.get('cedula') as FormControl;
  }
  get placaControl(): FormControl {
    return this.formValidation2.get('placa') as FormControl;
  }
  get tip_DocControl(): FormControl {
    return this.formValidation2.get('tip_Doc') as FormControl;
  }
  get nombresControl(): FormControl {
    return this.formValidation2.get('nombres') as FormControl;
  }
  get apellidosControl(): FormControl {
    return this.formValidation2.get('apellidos') as FormControl;
  }

  get celControl(): FormControl {
    return this.formValidation2.get('celular') as FormControl;
  }

  get correoControl(): FormControl {
    return this.formValidation2.get('correo') as FormControl;
  }
  get vinControl(): FormControl {
    return this.formValidation2.get('vin') as FormControl;
  }
  get termsCheckedControl(): FormControl {
    return this.formValidation2.get('terms') as FormControl;
  }
  get dataProtectionPoliticsControl(): FormControl {
    return this.formValidation2.get('politics') as FormControl;
  }
  get representativeDocumentTypeControl(): FormControl {
    return this.formValidation_representative.get(
      'representativeDocumentType'
    ) as FormControl;
  }

  get representativeDocumentNumberControl(): FormControl {
    return this.formValidation_representative.get(
      'representativeDocumentNumber'
    ) as FormControl;
  }
  get representativeNameControl(): FormControl {
    return this.formValidation_representative.get(
      'representativeName'
    ) as FormControl;
  }
  get representativeLastNameControl(): FormControl {
    return this.formValidation_representative.get(
      'representativeLastName'
    ) as FormControl;
  }
  get representativeCountryCodeControl(): FormControl {
    return this.formValidation_representative.get(
      'representativeCountryCode'
    ) as FormControl;
  }
  get representativePhoneControl(): FormControl {
    return this.formValidation_representative.get(
      'representativePhone'
    ) as FormControl;
  }
  get representativeRelationWithOwnerControl(): FormControl {
    return this.formValidation_representative.get(
      'representativeRelationWithOwner'
    ) as FormControl;
  }
  get representativecorreoControl(): FormControl {
    return this.formValidation_representative.get(
      'representativecorreo'
    ) as FormControl;
  }
  get tip_serviceControl(): FormControl {
    return this.formValidation.get('tip_service') as FormControl;
  }
  get kilometrajeControl(): FormControl {
    return this.formValidation.get('kilometraje') as FormControl;
  }

  get asesorControl(): FormControl {
    return this.formValidation.get('asesor') as FormControl;
  }
  get observationsControl(): FormControl {
    return this.formValidation.get('observations') as FormControl;
  }

  get typeCarControl(): FormControl {
    return this.formValidation.get('typeCar') as FormControl;
  }

  get makeCarControl(): FormControl {
    return this.formValidation.get('makeCar') as FormControl;
  }
}
